import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.$select = this.$('select')[0]

        // Save existing sort parameters
        this.queryParams = {};
        this.saveExistingSortParameters()

        // Bind events
        this.bindEvents()
    }

    bindEvents() {
        this.onChange = this.onChange.bind(this)
        this.$select.addEventListener('change', this.onChange)
    }

    unbindEvents() {
        this.$select.removeEventListener('change', this.onChange)
    }

    onChange(e) {
        const value = e.currentTarget.value;
        this.queryParams.sort_by = value;
        location.search = new URLSearchParams(this.queryParams).toString();
    }

    saveExistingSortParameters() {
        if(location.search.length) {
            for(var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
            aKeyValue = aCouples[i].split('=');
                if (aKeyValue.length > 1) {
                    this.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                }
            }
        }
    }

    destroy() {
        super.destroy()
        this.unbindEvents()
    }
}